export default [
  {
    path: '/vinculo-acompanhamento',
    component: () => import('@/pages/VinculoAcompanhamento/Index.vue'),
  },
  {
    path: '/acompanhamento',
    component: () =>
      import('@/pages/VinculoAcompanhamento/Acompanhamento/Template.vue'),
    children: [
      {
        path: '/acompanhamento',
        component: () =>
          import('@/pages/VinculoAcompanhamento/Acompanhamento/Index.vue'),
      },
    ],
  },
  {
    path: '/diagnostico-situacional',
    component: () =>
      import(
        '@/pages/VinculoAcompanhamento/DiagnosticoSituacional/Template.vue'
      ),
    children: [
      {
        path: '/diagnostico-situacional',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/DiagnosticoSituacional/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/vinculo-acompanhamento/recursos',
    component: () => import('@/pages/VinculoAcompanhamento/Recursos/Index.vue'),
  },
  {
    path: '/agenda-por-profissional',
    component: () =>
      import(
        '@/pages/VinculoAcompanhamento/AgendaPorProfissional/Template.vue'
      ),
    children: [
      {
        path: '/agenda-por-profissional',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/AgendaPorProfissional/Index.vue'
          ),
      },
      {
        path: '/agenda-por-profissional/equipe/acs',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/AgendaPorProfissional/PorEquipeAcs.vue'
          ),
      },
      {
        path: '/agenda-por-profissional/profissional',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/AgendaPorProfissional/PorAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/avaliacao-atendimentos',
    component: () =>
      import('@/pages/VinculoAcompanhamento/AvaliacaoAtendimentos/Index.vue'),
  },
  {
    path: '/condicoes-saude',
    component: () =>
      import('@/pages/VinculoAcompanhamento/CondicoesSaude/Template.vue'),
    children: [
      {
        path: '/condicoes-saude',
        component: () =>
          import('@/pages/VinculoAcompanhamento/CondicoesSaude/Index.vue'),
      },
    ],
  },
]
